import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Quality",
  "lead": "على مستوى العالم، يتم تدريب معظم المعلمين، ولكن في منطقة أفريقيا جنوب الصحراء الكبرى، انخفضت نسبة المعلمين المدربين تدريجيًا من 85% في عام 2000 إلى 64% في عام 2022."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, QualityFramework, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!QualityFramework) _missingMdxReference("QualityFramework", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_QUALITY"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "لا يمكن مساواة التعليم الجيد بنتائج التعلم أو تقليصه إليها. ويُحرم عدد هائل من الأطفال من المعلمين المدربين تدريبًا كافيًا، أو البنية التحتية المدرسية الجيدة، أو بيئة تعليمية آمنة وخالية من العنف."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "من الصعوبة بمكان مراقبة جودة التعليم؛ لأن كل دولة تفهمه وتضع له تعريفًا بطرق شتى. وباستثناء نتائج التعلم، لا يوجد العديد من المؤشرات لقياس الجودة في الهدف العالمي للتعليم، وهو الهدف الرابع من أهداف التنمية المستدامة."
    }), "\n", _jsx(_components.h2, {
      id: "المعلمون",
      children: "المعلمون"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.c.2",
      children: [_jsx(_components.p, {
        children: "المعلمون هم حجر الأساس في جودة التعليم. ومع ذلك، بعد عام 2000، وفي إطار الجهود الرامية إلى تحقيق التعليم الابتدائي الشامل، التحق عدد أكبر بكثير من الطلاب بالفصول الدراسية، ولم تكن عملية توظيف المعلمين مواكبة للوتيرة المتسارعة. ونتيجة لذلك، أصبحت الفصول الدراسية مكتظة بالطلاب، كما تدهورت جودة التعليم."
      }), _jsx(QualityFramework, {
        highlighted: "المعلمون",
        description: "تعرف على المزيد حول إطار جودة التعليم"
      }), _jsx(_components.p, {
        children: "تُظهر الرسوم البيانية أدناه نسبة التلاميذ إلى المعلمين في المدارس. وفي بعض بلدان أفريقيا جنوب الصحراء الكبرى، ورغم تحسن النسبة منذ عام 2000، فإن نسبة التلاميذ إلى المعلمين لا تزال أسوأ مما كانت عليه في ثمانينيات القرن العشرين."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PTR"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["في ", _jsx(HighlightByIndex, {
              index: "0",
              children: "منطقة أفريقيا جنوب الصحراء الكبرى،"
            }), "، بعد الجهود المبذولة لجعل التعليم الابتدائي مجانيًا بين عامَي 1990 و2000، التحق الأطفال بالفصول الدراسية بسرعة أكبر من قدرة البلدان على توظيف معلمين جدد. وقد ارتفعت نسبة التلاميذ إلى المعلمين بشكل هائل في كثير من الأحيان نتيجة لذلك."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["في ", _jsx(HighlightByIndex, {
              index: "6",
              children: "أوروبا وأمريكا الشمالية،"
            }), "، ظلت النسبة ثابتة عند نحو 14 طالبًا لكل معلم منذ عام 2005."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "إن التدريس مهمة صعبة والمعلمون الذين لم يتم إعدادهم بشكل جيد يدخلون الفصول الدراسية وهم يعانون من عجز خطير. هناك طريقتان رئيسيتان يمكن للدول من خلالهما قياس مدى استعدادها. يتم تقييم المعلمين من خلال:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["أولًا، ما إذا كانوا  ", _jsx(_components.strong, {
          children: "مؤهلين"
        }), " وهو ما يشير إلى ما إذا كانوا يمتلكون المؤهلات الأكاديمية المتوقعة وفقًا للمعايير الوطنية أم لا."]
      }), "\n", _jsxs(_components.li, {
        children: ["ثانيًا، ما إذا كانوا ", _jsx(_components.strong, {
          children: "مدربين"
        }), "، وهو الأمر الذي يقيّم ما إذا كانوا قد تلقوا تدريبًا مناسبًا كمعلمين أم لا، بغض النظر عن مؤهلاتهم."]
      }), "\n"]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.c.1",
      children: [_jsxs(_components.p, {
        children: ["إن التدريب يعني أن المعلمين تلقوا تدريبًا في ", _jsx(Tooltip, {
          title: "المعرفة التربوية",
          content: "المعرفة حول مناهج وطرق وتقنيات التدريس.",
          children: "المعرفة التربوية"
        }), " و", _jsx(Tooltip, {
          title: "المعرفة المهنية",
          content: "المعرفة بشأن، على سبيل المثال، الأطر القانونية التي تحكم مهنة التدريس.",
          children: "المعرفة المهنية"
        }), ". وقد تغطي بعض البرامج أيضًا ", _jsx(Tooltip, {
          title: "المعرفة بالمحتوى",
          content: "المعرفة بالمنهج الدراسي والموضوع واستخدام المواد ذات الصلة.",
          children: "المعرفة بالمحتوى"
        }), ". بيد أن نوع التدريب المطلوب يختلف من بلد إلى آخر، والمعلومات ذات الصلة نادرة. وبسبب هذه الاختلافات، وعلى الرغم من كونها عنصرًا حاسمًا في التعليم جيد النوعية، فإن المؤشر المتعلق بالمعلمين المدربين [4.ج.1] هو أحد أقل المؤشرات قابلية للمقارنة في إطار رصد الهدف الرابع من أهداف التنمية المستدامة."]
      }), _jsxs(_components.p, {
        children: ["على الصعيد العالمي، فإن غالبية المعلمين مؤهلون أو مدربون أو كليهما. على سبيل المثال، في ", _jsx(HighlightByIndex, {
          index: "3",
          children: "أمريكا اللاتينية ومنطقة البحر الكاريبي"
        }), "، تلقى 80% من المعلمين التدريب اللازم."]
      }), _jsxs(_components.p, {
        children: ["وعلى النقيض من ذلك، انخفضت نسبة المعلمين المدربين في منطقة ", _jsx(HighlightByIndex, {
          index: "0",
          children: "جنوب الصحراء الكبرى في أفريقيا"
        }), "من 85% في عام 2000 إلى 64% في عام 2022."]
      }), _jsx(Figure, {
        id: "TRAINED"
      }), _jsx(_components.p, {
        children: "لا يوجد حل سحري للدول التي تفتقر إلى المعلمين المؤهلين والمدربين. لا يتوفر لدى العديد من المدارس العدد الكافي من المعلمين المؤهلين لتلبية الطلب؛ نظرًا لانخفاض عدد خريجي التعليم العالي بشكل عام. وهذا يوضح كيف يمكن أن تصبح المشاكل مترابطة داخل نظام التعليم: فالمشاكل في مستوى واحد، مثل إكمال المرحلة الإعدادية، يمكن أن تفضي بسهولة إلى عواقب وخيمة في أماكن أخرى، مثل العجز في عدد المعلمين المدربين للطلاب في وقت لاحق."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "البنية-التحتية",
      children: "البنية التحتية"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1e",
      children: [_jsxs(_components.p, {
        children: ["يجب أن تحتوي بيئة التعلم المناسبة على مرافق ", _jsx(_components.strong, {
          children: "المياه"
        }), " والصرف الصحي المناسبة، خاصة للفتيات. ومع ذلك، كانت المياه الأساسية متاحة في 53% فقط من المدارس الابتدائية في أفريقيا جنوب الصحراء الكبرى، و77% في شرق وجنوب شرق آسيا، و86% في وسط آسيا وجنوبها."]
      }), _jsx(QualityFramework, {
        highlighted: "المادة",
        description: "تعرف على المزيد حول إطار جودة التعليم"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1f",
      children: [_jsxs(_components.p, {
        children: ["وعلى وجه الخصوص، قد لا تعتبر المرافق ", _jsx(_components.strong, {
          children: "الصحية"
        }), " التي تفتقر إلى الخصوصية آمنة، في حين أن المرافق التي لا يمكن فيها ممارسة النظافة الصحية أثناء الدورة الشهرية قد تمنع الفتيات من الذهاب إلى المدرسة. ومن ثم، فإن توفير مرافق صرف صحي منفصلة للجنسين يُعد خطوة سياسية حاسمة لمنع انتشار التأخر في الالتحاق بالمدارس الابتدائية وانقطاع الإناث عن الدراسة بمرور الوقت."]
      }), _jsx(_components.p, {
        children: "ويبين الرسم البياني أدناه أن أقل من نصف المدارس الابتدائية لديها مرافق صحية منفصلة للجنسين، ليس فقط في بلدان أفريقيا جنوب الصحراء الكبرى، بل وأيضًا في بلدان آسيوية مثل أفغانستان وجمهورية لاو الديمقراطية الشعبية ونيبال. في إندونيسيا، يكون لدى 43% فقط من المدارس الابتدائية، و56% من المدارس الإعدادية، و65% من المدارس الثانوية إمكانية الوصول إلى مرافق الصرف الصحي غير المختلطة."
      }), _jsx(Figure, {
        id: "SANITATION"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1a",
      children: [_jsxs(_components.p, {
        children: ["إن ", _jsx(_components.strong, {
          children: "الكهرباء"
        }), " هي حاجة أساسية لبيئة تعليمية ذات جودة عالية، ومع ذلك فإن العديد من البلدان تفتقر إليها. في البلدان ذات الدخول المنخفضة، 73% من المدارس الابتدائية و58% من المدارس الثانوية لا تتوفر فيها الكهرباء."]
      }), _jsx(_components.p, {
        children: "وكما يوضح الرسم البياني أدناه، فإن أقل من نصف عدد المدارس الابتدائية في نيكاراجوا وباكستان تنعم بالكهرباء. في بعض بلدان أفريقيا جنوب الصحراء الكبرى، يُعد الحصول على الكهرباء في المدارس نادرًا للغاية: إن نسبة 12% من المدارس في مدغشقر لديها كهرباء و4% فقط في تشاد. بدون الكهرباء، قد يكون الضوء غير كافٍ، ولا يستطيع المعلمون استخدام أجهزة الكمبيوتر سواء للإدارة أو التدريب. إن نقص الكهرباء يعني الافتقار إلى التهوية أو التبريد أو التدفئة، مما قد يجعل الفصول الدراسية غير مناسبة للتدريس والتعلم."
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.1b",
      children: [_jsxs(_components.p, {
        children: ["إن نقص الكهرباء يعني أيضًا أن استخدام التكنولوجيا ", _jsx(_components.strong, {
          children: "والإنترنت"
        }), " أمر مستحيل. ومع ذلك، فإن الكهرباء ليست العامل الوحيد الذي يعرقل انتشار الإنترنت. في البلدان ذات الدخول المتوسطة، 37% من المدارس الابتدائية و22% من المدارس الثانوية لديها الكهرباء، ولكن ليس لديها إنترنت. حتى لو كانت المدارس متصلة بمصدر طاقة، فإن تذبذب التيار الكهربائي وانقطاعه أمر شائع الحدوث. تعتمد إمكانية الاتصال بالإنترنت على البنية التحتية للاتصالات الوطنية، والموقع الجغرافي، وقدرة المدارس على دفع تكاليف الخدمة."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "ELECTRIC"
          })
        }), _jsx(ScrollySection, {
          id: "LKA",
          children: _jsxs(_components.p, {
            children: ["في ", _jsx(_components.strong, {
              children: "سريلانكا"
            }), "، على الرغم من أن جميع المدارس الابتدائية بها كهرباء، إلا أن 41% فقط منها لديها إمكانية الوصول إلى الإنترنت. والشيء نفسه ينطبق على 34% من المدارس في تركمانستان و32% في الأردن."]
          })
        }), _jsx(ScrollySection, {
          id: "ECU,URY",
          children: _jsxs(_components.p, {
            children: ["العديد من بلدان أمريكا اللاتينية لديها مدارس لا يوجد بها كهرباء ولا إنترنت. في ", _jsx(_components.strong, {
              children: "الإكوادور"
            }), "، حوالي 43% فقط من المدارس و63% في الأرجنتين يمكنها القول إن لديها سبل الوصول إلى كلتا الخدمتين. والاستثناء الوحيد هو ", _jsx(_components.strong, {
              children: "الأوروغواي"
            }), "؛ حيث تتمتع 100% من مدارسها الابتدائية بالقدرة على الوصول إلى كلتا الخدمتين."]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "العنف",
      children: "العنف"
    }), "\n", _jsx(_components.p, {
      children: "يمكن أن تكون الأفعال العنيفة أو التهديدات المرتبطة بالمدرسة نفسية أو جسدية أو جنسية وتحدث في حرم المدرسة، ولكن أيضًا في الطريق إلى المدرسة أو في المنزل أو في الفضاء الإلكتروني. إنها تنشأ في كثير من الأحيان بسبب ديناميكيات القوة غير المتكافئة، وغالبًا ما تكون نتيجة للمعايير النمطية الجنسانية السلبية."
    }), "\n", _jsx(_components.p, {
      children: "في حين ينصبّ الاهتمام عادةً على الأحداث المتطرفة مثل إطلاق النار، فإن أشكال العنف الأكثر شيوعًا، والتي غالبًا ما تمر دون أن يلاحظها أحد، مثل التنمر، هي التي لها التأثير السلبي الأكبر على تعليم الأطفال والمراهقين. وتظل البيانات المتعلقة بهذه القضايا غير كافية؛ لأن الأسئلة التي يتم طرحها عند جمع البيانات تتضمن تعريفات مختلفة للسلوك العنيف، ومقاييس زمنية مختلفة للإبلاغ، وخيارات استجابة غير قابلة للمقارنة، وترتيبات الخصوصية أو البروتوكولات الأخلاقية. هذا بالإضافة إلى عدم الإبلاغ بشكل كافٍ عن أشكال العنف مثل التنمر المرتبط برهاب المثلية الجنسية، والتي تنطوي على محرمات."
    }), "\n", _jsx(QualityFramework, {
      highlighted: "school",
      description: "Learn more about the framework for education quality"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.a.2",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "التنمر"
        }), " هو الشكل الأكثر توثيقًا للعنف في المدارس. ويمكن أن يشمل ذلك العنف الجسدي، والإساءة اللفظية، والنية لإحداث إيذاء نفسي من خلال الإذلال أو الإقصاء. يوضح الشكل أدناه أن مراهقًا واحدًا على الأقل من كل ثلاثة مراهقين، وغالبًا ما يكون عدد الأولاد أكبر من عدد البنات، يقع ضحية للتنمر في معظم البلدان."]
      }), _jsx(Figure, {
        id: "BULLY_FIGHT"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "العنف الجسدي"
      }), " يشمل الانخراط في معارك جسدية في المدرسة، أو حمل سلاح أو التهديد به مثل المسدس أو السكين أو الهراوة على ممتلكات المدرسة، أو كونه عضوًا في عصابة أو مشاركًا فيها، أو التعرض للعنف الجسدي على يد أحد أعضاء الموظفين."]
    }), "\n", _jsx(_components.p, {
      children: "أفاد ما لا يقل عن 10% من الأولاد البالغين من العمر 15 عامًا في 24 دولة أنهم شاركوا في معارك جسدية 3 مرات أو أكثر في عام 2022، وبلغ معدل الانتشار أكثر من 30% في أرمينيا."
    }), "\n", _jsx(_components.h2, {
      id: "خاتمة",
      children: "خاتمة"
    }), "\n", _jsx(_components.p, {
      children: "وفي الوقت ذاته، فإن البيانات القابلة للمقارنة دوليًا بشأن مؤشرات المعلمين تتسم بالندرة بشكل يبعث على الدهشة. إن عدد البلدان التي تبلغ عن تعداد المعلمين الأساسي قليل نسبيًا، وهذا لا يأخذ في الاعتبار ساعات التدريس والمعلمين في المناصب الإدارية وغير ذلك من التعقيدات. إننا بحاجة إلى وضع تصنيف للمعايير الخاصة بالمعلمين المدربين حتى نتمكن من رؤية الفجوات بشكل صحيح ورفع هذه القضية إلى المستوى العالمي."
    }), "\n", _jsx(_components.p, {
      children: "إن توفير مرافق تعليمية \"تراعي احتياجات الأطفال والإعاقة والجنسين\" و\"بيئات تعليمية آمنة وغير عنيفة وشاملة وفعالة للجميع\" يمثل تحديًا في العديد من البلدان كما يوضح هذا المقال. وفي الوقت ذاته، يُعد قياس التقدم المحرز في هذه القضية أمرًا صعب المنال؛ لأن المؤشر العالمي ذي الصلة ليس المقياس الأوحد، بل هناك مجموعة من الأبعاد المتعددة."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.oecd-ilibrary.org/education/education-at-a-glance_19991487",
            children: "Education at a glance – OECD (نظرة عامة على التعليم – منظمة التعاون الاقتصادي والتنمية)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://theirworld.org/news/safe-schools-report-reveals-crises-challenges-action-needed-to-educate-children",
            children: "Safe Schools Report – Their World (تقرير المدارس الآمنة – عالمهم)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark%E2%80%8F:/48223/pf0000232107",
            children: "School-related gender-based violence is preventing the achievement of quality education for all (العنف القائم على النوع الاجتماعي في المدارس يحول دون حصول الجميع على التعليم الجيد)"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
